// extracted by mini-css-extract-plugin
export var content = "Blog-module--content--95978";
export var image = "Blog-module--image--4750b";
export var post = "Blog-module--post--057c1";
export var postLatest = "Blog-module--postLatest--b2cb5 Box-module--box--d60cf Blog-module--post--057c1";
export var postSmall = "Blog-module--postSmall--c4ea9 Blog-module--post--057c1";
export var subtitle = "Blog-module--subtitle--c4655";
export var title = "Blog-module--title--f6641";